// extracted by mini-css-extract-plugin
export default {"issueTypeDot":"IssueTypeDot-module__issueTypeDot--OP0zu"};